export default __webpack_public_path__ + "static/media/mailchimp-header.62cbc64f.png";